
import { IonBadge, IonButtons, IonButton, IonIcon } from '@ionic/vue';
import { mailOutline } from 'ionicons/icons';
import { computed, defineComponent, onMounted, onUnmounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { useMensajesUnreadStore } from '@/stores/mensajesUnread';

const RESALTADO_INTERVAL_MS = 15000;
const RESALTADO_DURACION_MS = 900;

export default defineComponent({
  name: 'GalidanciaHomeLogo',
  components: { IonBadge, IonButtons, IonButton, IonIcon },
  setup() {
    const router = useRouter();
    const unreadStore = useMensajesUnreadStore();
    const { count: unreadCount } = storeToRefs(unreadStore);
    const resaltando = ref(false);
    let intervalId: ReturnType<typeof setInterval> | null = null;
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const dispararResaltado = () => {
      resaltando.value = false;
      requestAnimationFrame(() => {
        resaltando.value = true;
      });
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        resaltando.value = false;
      }, RESALTADO_DURACION_MS);
    };

    onMounted(() => {
      intervalId = setInterval(dispararResaltado, RESALTADO_INTERVAL_MS);
    });

    onUnmounted(() => {
      if (intervalId) clearInterval(intervalId);
      if (timeoutId) clearTimeout(timeoutId);
    });

    const goInicio = () => {
      const path = router.currentRoute.value.path || '';
      if (path === '/tabs/inicio' || path === '/tabs/inicio/') return;
      router.push('/tabs/inicio');
    };

    const goMensajes = () => {
      void router.push('/tabs/mensajes');
    };

    const unreadBadgeText = computed(() => {
      const n = unreadCount.value;
      if (n > 99) return '99+';
      return String(n);
    });

    return { goInicio, goMensajes, resaltando, mailOutline, unreadCount, unreadBadgeText };
  },
});
